<div class="flex flex-justify-start policy-hero-banner padding-medium policy-hero-banner--light">
  <div class="flex flex-column flex-grow">
    <div class="policy-info flex flex-column">

      <button mat-icon-button color="primary" (click)="navigateBack()" class="policy-info-back">
        <mat-icon>west</mat-icon>
      </button>

      <h3 class="policy-hero-banner-title">{{ data.policyTitle }}</h3>

      <div class="policy-type flex flex-row">
        <div class="policy-type-icon margin-right-tiny">
          <open-svg-icon [name]="data.icon" class="xsmall light policy-type-icon"></open-svg-icon>
        </div>
        <span>{{ data.policyTypeLabel }}</span>
      </div>

      <div class="policy-badges margin-bottom-small">
        <open-badge [label]="data.policyState" [variant]="badgeStatus[data.policyState]"></open-badge>
        <open-badge *ngIf="data.autoRenew && data.policyState === 'active'" [label]="'Renews ' + (data.endDate | displayDate)" variant="inform" icon="autorenew" class="inform-badge"></open-badge>
      </div>

      <div class="flex flex-row flex-wrap policy-hero-banner-snapshot">
        <div class="flex flex-column margin-right-small">
          <span class="margin-bottom-tiny text-small">Policy number</span>
          <div class="flex">
            <strong>{{ data.policyNumber }}</strong>
            <mat-icon 
              class="mat-icon material-icons mat-ligature-font mat-icon-no-color margin-left-xxsmall policy-number-copy-icon"
              (click)="copyPolicyNumber(data.policyNumber)"
              [matTooltip]="'Copy policy number'"
            >content_copy</mat-icon>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="dynamicContent"></ng-container>
      </div>

      <ng-template #dynamicContent>
        <div [outerHTML]="dynamicMarkup"></div>
      </ng-template>
    </div>
  </div>
</div>